import Client from 'config/axios';

export const getAuthTokenSn = async (token: string, provider: string) => {
  return await Client.get(`get-authentication-url/${provider}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};
